<div class="box-menu-settings settings-image active mb-5">
	<span data-testid="SUBSYS4_IMAGEELABORATON_TOGGLE_BTN" class="title-accordion bg-transparent m-0"
		[class.active]="!isCollapsed" (click)="isCollapsed = !isCollapsed" (keypress)="isCollapsed = !isCollapsed">
		{{ labels().IMAGE_ELABORATION_COMPONENT_TITLE }}
		<div class="fake-material-icon icon-expand expand"></div>
	</span>

	<div [ngbCollapse]="isCollapsed">

		<div class="wrapper-image-setup">
			<div data-testid="SUBSYS4_IMAGEELABORATON_LINE_BTN" class="img-action clickable"
				[title]="labels().IMAGE_ELABORATION_COMPONENT_LINE" (click)="addLine()" (keypress)="addLine()">
				<i class="material-icons">straighten</i>
			</div>
			<div data-testid="SUBSYS4_IMAGEELABORATON_GONIOMETER_BTN" class="img-action clickable"
				[title]="labels().IMAGE_ELABORATION_COMPONENT_GONIOMETER" (click)="addGoniometer()"
				(keypress)="addGoniometer()">
				<div class="fake-material-icon protractor"></div>
			</div>
			<div data-testid="SUBSYS4_IMAGEELABORATON_DELETE_BTN" class="img-action"
				[title]="labels().IMAGE_ELABORATION_COMPONENT_DELETE"
				[class]="{'clickable': isDeleteEnabled, 'disabled': !isDeleteEnabled }" style="margin-left: 5rem;"
				(click)="deleteTool()" (keypress)="deleteTool()">
				<div class="material-icons" style="cursor: inherit;">delete_outline</div>
			</div>
		</div>
		<div class="row-box">
			<i class="material-icons">brightness_5</i>
			<span>{{ labels().IMAGE_ELABORATION_COMPONENT_BRIGHTNESS }}</span>
		</div>
		<div class="row-box">
			<input id="brightnessSlider" type="text" />
		</div>
		<div class="row-box">
			<i class="material-icons">tonality</i>
			<span>{{ labels().IMAGE_ELABORATION_COMPONENT_CONTRAST }}</span>
		</div>
		<div class="row-box">
			<input id="contrastSlider" type="text" />
		</div>
		<div class="wrapper-image-setup">
			<div data-testid="SUBSYS4_IMAGEELABORATON_ROTATE_BTN" class="img-action"
				[title]="labels().IMAGE_ELABORATION_COMPONENT_ROTATE"
				[class]="{'clickable': isEditToolEnabled, 'disabled': !isEditToolEnabled }" (click)="openRotateModal()"
				(keypress)="openRotateModal()">
				<i class="material-icons" style="cursor: inherit;">rotate_right</i>
			</div>
			<div data-testid="SUBSYS4_IMAGEELABORATON_CROP_BTN" class="img-action"
				[title]="labels().IMAGE_ELABORATION_COMPONENT_CROP"
				[class]="{'clickable': isEditToolEnabled, 'disabled': !isEditToolEnabled }" (click)="openCropModal()"
				(keypress)="openCropModal()">
				<i class="material-icons" style="cursor: inherit;">crop</i>
			</div>
		</div>

	</div>
</div>